module.exports = __webpack_public_path__ + "static/img/sj_js_3.39ae444.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sj/sj_js_3.png
// module id = E+fg
// module chunks = 1